import {
  background,
  border,
  coloring,
  composeGroups,
  createView,
  flexContainer,
  flexItem,
  layout,
  positioning,
  sizing,
  spacing,
  type KitViewProps
} from '../_support'

/* -----------------------------------------------------------------------------
 * Box
 *
 * A react-native View with the layout style props (spacing, flexbox, borders,
 * colors, position). No typography: use Text.
 * -------------------------------------------------------------------------- */

export const boxStyles = composeGroups(
  background,
  border,
  coloring,
  flexContainer,
  flexItem,
  layout,
  positioning,
  sizing,
  spacing
)

// styleKeys: the props Box styles, for components that split props between parts
const Box = Object.assign(
  createView({ displayName: 'Box', groups: boxStyles }),
  {
    styleKeys: new Set(Object.keys(boxStyles))
  }
)

export type BoxProps = KitViewProps

export default Box
